<template>
	<div class="plr-16 box-s" :class="{'pb-30': padShow }" id="contain">
      <div v-for="(item, index) in list" :key="index" >
        <!-- 每道题上部的题号和类型 -->
				<div :class="{ 'pt-66': item.stuff_id != 0 }" v-if="qusetNum == (index + 1)">
					<div class="quest_header flexs h66 bg_f" :class="{ 'ps_top': item.stuff_id != 0, 'plr-16': item.stuff_id != 0 }">
						<div class="c1 fz-16 mb-6"> <span class="fz-28 fw-500">{{qusetNum}}</span> <span class="fw-500">/</span> <span class="c2">{{length}}</span> </div>
						<template v-if="item.stuff_id == 0">
							<div v-if="item.question_type == 1" class="tag_class ml-5 bg_ff c13">单选题</div>
							<div v-if="item.question_type == 2" class="tag_class ml-5 bg_dc c12">多选题</div>
							<div v-if="item.question_type == 3" class="tag_class ml-5 bg_ea c11">判断题</div>
							<div v-if="item.question_type == 5" class="tag_class ml-5 bg_d8 c0">填空题</div>
							<div v-if="item.question_type == 4" class="tag_class ml-5 bg_d8 c0">简答题</div>
						</template>
						<div v-else class="tag_class ml-5 bg_bb c16">材料题</div>
					</div>
				</div>
				
				<!-- 材料题总题干 -->
				<div v-if="item.stuff_id != 0 && (qusetNum == (index + 1))" class="pt-155">
					<div class="mb-22 box_shaw_6 ps_top top66 plr-16 bg_f box-s">
						<div  class="over-auto cail trans" :ref="'DOM' + index" :style="{ 'height': cheight + 'px' }">
							<div class="fz-14 fw-500 c1" v-if="item.stuff"  v-html="item.stuff"></div>
						</div>
						<div class="flexs flex-center box-s c0 fz-12 fw-500 l-h-40"  @click="showHe">
							<div class="flexs flex-center l-h-40" v-if="showFlag">
								<div>{{txtflag? '收起': '展开'}}</div>
								<span v-if="!txtflag" class="iconfont icon-arrow-down fz-10 ml-7"></span>
								<span v-else class="iconfont icon-shangjiantou fz-10 ml-7"></span>
							</div>
						</div>
					</div>
				</div>

				<!-- 小题题干 -->
				<div class="fz-14 fw-500 c1 mb-22" v-if="qusetNum == (index + 1)" v-html="item.question_stem"></div>
				
				<!-- 每道题的主体 -->
				<div class="">
					<!-- 单选题 -->
					<ul class="fz-14 c1" v-if="item.question_type == 1 && qusetNum == (index + 1)">
						<li class="flexs mb-22 pd-20-16 bg_f8  b-radius-6 bb-ff box-s flex-jus" :class="{  'checked': recordList[index].isAnswer && item.right_answer[0] == Object.keys(innerItem)[0], 'error_checked': recordList[index].isAnswer &&  item.right_answer[0] != Object.keys(innerItem)[0]&& recordList[index].student_answer[0] == Object.keys(innerItem)[0],'tag_active': !recordList[index].isAnswer && recordList[index].student_answer[0] == Object.keys(innerItem)[0]}" v-for="(innerItem, innerindex) in item.prepare_option" :key="innerindex" @click="getcheck(Object.keys(innerItem)[0],index, 1)">
							<div class="flexs flex1">
								<div class="">{{Object.keys(innerItem)[0]}}.</div>
								<div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
							</div>
							<div v-if="recordList[index].isAnswer" class="ml-10">
								<img v-if="  item.right_answer[0] != Object.keys(innerItem)[0]&& recordList[index].student_answer[0] == Object.keys(innerItem)[0]" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
								<img v-else-if=" item.right_answer[0] == Object.keys(innerItem)[0]" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
								
							</div>
						</li>
					</ul>

					<!-- 判断题 -->
					<ul class="fz-14 c1" v-if="item.question_type == 3 && qusetNum == (index + 1)">
						<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  'checked': recordList[index].isAnswer && item.right_answer == 'true', 'error_checked': recordList[index].isAnswer &&  item.right_answer == 'false'&& recordList[index].student_answer == 'true', 'tag_active': !recordList[index].isAnswer && recordList[index].student_answer == 'true' }" @click="getcheck('true',index,3)">
							<div class="flexs">
								<div class="">A.</div>
								<div class="ml-6" >正确</div>
							</div>
							<div v-if="recordList[index].isAnswer">
								<img v-if="item.right_answer == 'true'" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
								<img v-if="item.right_answer == 'false'&& recordList[index].student_answer == 'true'" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
							</div>
						</li>

						<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  'checked': recordList[index].isAnswer && item.right_answer == 'false', 'error_checked': recordList[index].isAnswer &&  item.right_answer == 'true'&& recordList[index].student_answer == 'false', 'tag_active': !recordList[index].isAnswer && recordList[index].student_answer == 'false' }" @click="getcheck('false',index, 3)">
							<div class="flexs">
								<div class="">B.</div>
								<div class="ml-6" >错误</div>
							</div>
							<div v-if="isAnswer">
								<img v-if="item.right_answer == 'false'" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
								<img v-if="item.right_answer == 'true'&& recordList[index].student_answer == 'false'" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
							</div>
						</li>
						
					</ul>
					

					<!-- 多选题 -->
					<div v-if="item.question_type == 2 && qusetNum == (index + 1)">
						<ul class="fz-14 c1" :class="{ 'mb-20': !recordList[index].isAnswer }">
							<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  'checked': recordList[index].isAnswer && item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1, 'error_checked': recordList[index].isAnswer && item.right_answer.indexOf(Object.keys(innerItem)[0]) == -1 && recordList[index].student_answer.indexOf(Object.keys(innerItem)[0]) != -1,'tag_active': recordList[index].isAnswer && item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1 && recordList[index].student_answer.indexOf(Object.keys(innerItem)[0]) == -1  || !recordList[index].isAnswer && recordList[index].student_answer.indexOf(Object.keys(innerItem)[0]) != -1}" v-for="(innerItem, innerindex) in item.prepare_option" :key="innerindex" @click="getcheck(Object.keys(innerItem)[0], index, 2)">
								<div class="flexs flex1">
									<div class="">{{Object.keys(innerItem)[0]}}.</div>
									<div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
								</div>
								<div class="ml-10" v-if="recordList[index].isAnswer">
									<img v-if="item.right_answer.indexOf(Object.keys(innerItem)[0]) == -1 && recordList[index].student_answer.indexOf(Object.keys(innerItem)[0]) != -1" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
									<div v-else-if="item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1 && recordList[index].student_answer.indexOf(Object.keys(innerItem)[0]) == -1" class="wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
									<img v-else-if="item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
									
								</div>
							</li>
						</ul>

						<div class="submit_quest_btn" @click="checkedSumbit" v-if="!recordList[index].isAnswer && !isAnswer">提交</div>
					</div>

					<!-- 填空题/简答题 -->
					<div v-if="(item.question_type == 4 || item.question_type == 5) && qusetNum == (index + 1)">
						<div  class="textarea_box mb-12">
							<textarea class="textarea" v-model="recordList[index].student_answer" :readonly="recordList[index].isAnswer" name="" id="" cols="30" rows="10" placeholder="请输入答案"></textarea>
						</div>

						<div class="mb-22">
							<addImg @addImg="addImg" :showDel="!recordList[index].isAnswer" @delImg="delImg" :isAnswer="recordList[index].isAnswer" :showAdd="!recordList[index].isAnswer" :imgList="recordList[index].imgList"/>
						</div>

						<div v-if="!recordList[index].isAnswer && !isAnswer" class="submit_quest_btn" @click="textSubmit">提交</div>
					</div>

				</div>
				
				<!-- 答案 -->
				<div v-if="(recordList[index].isAnswer || isAnswer) && qusetNum == (index + 1)" class="animal pt-22">
					<div class="mb-22">
						<div class="flexs flex-jus fw-500 c1">
							<div class="flexs">
								<img class="wh_32 mr-10" src="../../assets/img/icon/answer_icon.png" alt="">
								<div class="l-h-16 fz-16  ">题目解析～巩固你的知识吧！</div>
							</div>
							<div class="flexs fz-10 bg_f9 flex-center b-radius-10 wh_74_20" @click="jumpReaction">
								纠错反馈
								<img class="wh_4_6 ml-8" src="../../assets/img/icon/gray_right_arrow_icon.png" alt="">
							</div>
						</div>
					</div>

					<div class="fz-14 fw-500 c1 mb-10" :class="{ 'flexs':  !(item.question_type == 4 || item.question_type == 5)}">
						<div class="mr-30 flexs flex-align-start mb-10" v-if="item.question_type == 4 || item.question_type == 5">
							<div class="w75 wrp">正确答案：</div>
							<div class="c0 flex1">
								<div v-html="item.right_answer"></div>
							</div> 
						</div>

						<div class="mr-30 flex flex-align-start" v-else>
							<div class="w75 wrp">正确答案：
							</div>
							<div class="c0 flex1">
								{{!Array.isArray(item.right_answer)? (item.right_answer === ''? '暂无答案': (item.right_answer == 'true'? '正确': item.right_answer == 'false'?'错误': item.right_answer)): (item.right_answer.length == 0? '暂无答案': (item.right_answer.length == 1?item.right_answer[0]: item.right_answer.join('')))}}
							</div> 
						</div>

						<div class="flex flex-align-start" v-if="recordList[index].isAnswer">
							<div class="w75 wrp">你的答案：</div>
							<div class="c0 flex1" :class="{ 'c9': (recordList[index].is_result == 0) || (recordList[index].is_result == 2)  }">
								{{ !Array.isArray(recordList[index].student_answer)? (recordList[index].student_answer === ''? '未答': (recordList[index].student_answer == 'true'?'正确': recordList[index].student_answer =='false'?'错误':recordList[index].student_answer)): (recordList[index].student_answer.length == 0? '未答': (recordList[index].student_answer.length == 1?recordList[index].student_answer[0]: recordList[index].student_answer.join(''))) }}
							</div> 
						</div>
						
						
					</div>
					<div class="mb-10" v-if="recordList[index].imgList && recordList[index].imgList.length != 0">
						<addImg :imgList="recordList[index].imgList" :showDel="false" :showAdd="false"/>
					</div>

					<div class="fz-14  c1">
						<div class="fw-500 mb-8">题目解析：</div>
						<div v-if="item.analysis" v-html="item.analysis"></div>
					</div>
				</div>
      </div>
    <qusetBottom :cData="cData" @getAnswer="getAnswer" :questBtn="questBtn" :isAnswer="true" :length="length" :collectFalg="collectFalg" :qusetNum="qusetNum" @getQuest="getQuest" @collect="collect" @quertCard="quertCard" :answerFalg="isAnswer" :colectData="cData" :flag="flag"></qusetBottom>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import loading from "@/components/loading"
	import { siteTopic, siteRandomSubmitAnswer, randomGetAnswer } from '@/api/api.js'
	import {getShowPadding} from "@/utils/common.js";
	import qusetBottom from "@/components/qusetBottom.vue";
	import addImg from "@/components/addImg.vue";
	export default {
		components: {
      qusetBottom,
			addImg,
			loading
		},
		data() {
			return {
				list: [], //每一页的题数据
				recordList: [],//做题数据
				number: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U","V", "W", "X", "Y", "Z"],//题目前序号
				loadFlag: false,
				padShow: false, //是否展示底部30padding
				length: 0,
				qusetNum: 1, //第几道题
				isAnswer: false, //是否已答题
        collectFalg: false, //是否收藏到错题本
        showHeader: false,  //材料题头部动画
				hideHeader: false, //材料题头部动画
				flag: false, //材料题头部动画
				txtflag: false, //材料题头部动画
				timeflag: false, //材料题头部动画	
        cData: {
					question_id: '',
					model_type: 2,
					way: 2,
					base_id: ''
				},//收藏接口需要数据
				questBtn: false,
				cheight: '',
				commonHeight: '',
				showFlag: false
			};
		},
		created() {
      this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},

		methods: {
			init(){
        this.showHeader = false
        this.flag = false
        this.txtflag = false
        this.timeflag = false
			},
      async initData(){
				
        this.loadFlag = true
			  const res = await siteTopic({ examination_id: this.$route.query.examination_id})
        this.loadFlag = false
				if(res.code == 1000){
					this.init()
					this.list = res.data.topic
					const record = res.data.record
					
					this.recordList = this.list.map((item, index) => {
						if(record.findIndex(i => i.question_id == item.id) != -1){
							let data = record.findIndex(i => i.question_id == item.id)
							return {  is_result:  record[data].is_result, student_answer: record[data].student_answer, isAnswer: true, imgList: record[data].answer_picture? record[data].answer_picture : []}
						} else {
							if(item.question_type == 1 || item.question_type == 2){
                return {isAnswer: false, student_answer: [], imgList: []}
							} else {
								return { isAnswer: false, student_answer: '', imgList: [], imgid: [] }
							}
							
						}
					})
					
					const num = this.recordList.length - JSON.parse(JSON.stringify(this.recordList)).reverse().findIndex(i => i.isAnswer)
					this.qusetNum = this.$route.query.qusetNum?Number(this.$route.query.qusetNum):(record.length == 0?1: (num == this.recordList.length? num:(Number(num) + 1)))
					this.length = this.list.length
					this.collectFalg  = this.list[this.qusetNum - 1].answer_wrong_id == 0? false:true
          this.isAnswer = this.recordList[this.qusetNum - 1].isAnswer
					if(this.isAnswer){
            this.cData = { //收藏错题所需数据
							question_id: this.list[this.qusetNum - 1].id,
							model_type: 2,
							way: 3,
							base_user_id: this.list[this.qusetNum - 1].id
						}
					} else {
            this.cData = { //收藏错题所需数据
							question_id: this.list[this.qusetNum - 1].id,
							model_type: 2,
							way: 2,
							base_id: this.list[this.qusetNum - 1].id
						}
					}
          
					this.getCliao()
					
				
				} else {
					this.$toast(res.msg)
				}
			},

			getCliao(){
				this.cheight = ''
				this.commonHeight = ''
				this.showHeader = false
				this.txtflag = false
        if(this.list[this.qusetNum - 1].stuff_id != 0){
					this.$nextTick(()=>{
						const r = document.documentElement.clientWidth / 375
						this.commonHeight = this.$refs['DOM'+ (this.qusetNum - 1)][0]?this.$refs['DOM'+ (this.qusetNum - 1)][0].offsetHeight * r:this.$refs['DOM'+ (this.qusetNum - 1)].offsetHeight
						this.cheight = 98 * r
						this.showFlag = this.commonHeight > this.cheight
						console.log(1111, this.commonHeight, this.cheight,this.$refs['DOM'+ (this.qusetNum - 1)][0])
					})
				}
			},

      // 切换单选题 / 判断题 /多选题
		  getcheck(item, index,type){
				if(this.isAnswer || this.recordList[this.qusetNum - 1].isAnswer){
          return
				}
				if(type == 1){
          this.recordList[index].student_answer = [item]
				} else if(type == 2){
					
          if(this.recordList[index].student_answer.indexOf(item) != -1){
            this.recordList[index].student_answer.splice( this.recordList[index].student_answer.indexOf(item) , 1)
					} else {
						this.recordList[index].student_answer.push(item)
					}
				} else {
          this.recordList[index].student_answer = item
				}

				if(type == 1 || type == 3){
          this.getSubmit()
				}
			},

			// 提交答案
			async getSubmit(picture){
        const res = await siteRandomSubmitAnswer({
					id: this.list[this.qusetNum - 1].id,
					examination_id: this.$route.query.examination_id,
					answer: JSON.stringify(this.recordList[this.qusetNum - 1].student_answer),
					picture
				})
				if(res.code == 1000){
          this.recordList[this.qusetNum - 1].isAnswer = true
          this.recordList[this.qusetNum - 1].is_result = res.data.is_result
					this.isAnswer = true
					this.cData = { //收藏错题所需数据
						question_id: this.list[this.qusetNum - 1].id,
						model_type: 2,
						way: 3,
						base_user_id: this.list[this.qusetNum - 1].id
					}
				}else {
					this.$toast(res.msg)
				}
			},
      
			// 提交多选题
			async checkedSumbit(){
				if(this.recordList[this.qusetNum - 1].isAnswer){
          return
				}
				this.getSubmit()
			},
      
			// 提交简答题
			async textSubmit(){
				if(this.recordList[this.qusetNum - 1].isAnswer){
          return
				}
				const picture = this.recordList[this.qusetNum - 1].imgid.length == 0? '':(this.recordList[this.qusetNum - 1].imgid.length == 1? `${this.recordList[this.qusetNum - 1].imgid[0]}`:this.recordList[this.qusetNum - 1].imgid.join(''))
				this.getSubmit(picture)
			},


			// 上一页，下一页
			getQuest(type){
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				if(type == '1'){
					this.qusetNum = this.qusetNum - 1
				} else if (type == '2') {
					this.qusetNum =this.qusetNum + 1
				}
				this.getCliao()
				this.isAnswer = this.recordList[this.qusetNum - 1].isAnswer
				if(this.isAnswer){
          this.cData = { //收藏错题所需数据
						question_id: this.list[this.qusetNum - 1].id,
						model_type: 2,
						way: 3,
						base_user_id: this.list[this.qusetNum - 1].id
					}
				} else {
          this.cData = { //收藏错题所需数据
						question_id: this.list[this.qusetNum - 1].id,
						model_type: 2,
						way: 2,
						base_id: this.list[this.qusetNum - 1].id
					}
				}
				this.collectFalg  = this.list[this.qusetNum - 1].answer_wrong_id == 0? false:true
        
			},
      
			// 添加图片
			async addImg(data){
				if(this.recordList[this.qusetNum - 1].isAnswer){
          return
				}
        this.recordList[this.qusetNum - 1].imgList.unshift(data.path)
        this.recordList[this.qusetNum - 1].imgid.unshift(data.id)
			},
     
		  // 删除图片
			delImg(index){
				if(this.recordList[this.qusetNum - 1].isAnswer){
          return
				}
        this.recordList[this.qusetNum - 1].imgList.splice(index, 1)
				this.recordList[this.qusetNum - 1].imgid.splice(index, 1)
			},

			// 收藏
			collect(collectFalg){
        this.collectFalg = !collectFalg
				this.list[this.qusetNum - 1].answer_wrong_id = this.collectFalg? true: false
			},
			// 查看答题卡
			quertCard(){
        this.$router.replace({path: '/textcard', query:{examination_id: this.$route.query.examination_id, qusetNum: this.qusetNum } })
			},

			// 查看答案
			async getAnswer(){
				if(this.recordList[this.qusetNum - 1].isAnswer){
          return
				}
				this.isAnswer = !this.isAnswer
        
			},
      
			// 材料题展开收起
			showHe(){
				  if(!this.showFlag) return
          if(!this.showHeader){
            const h = document.documentElement.clientHeight * (document.documentElement.clientWidth / 375) * 0.55
						this.cheight = this.commonHeight > h ? h : this.commonHeight
					} else {
						this.cheight = 98 * (document.documentElement.clientWidth / 375)
						this.$nextTick(() => {
								this.$refs['DOM'+ (this.qusetNum - 1)][0]?this.$refs['DOM'+ (this.qusetNum - 1)][0].scrollTo(0,0): this.$refs['DOM'+ (this.qusetNum - 1)].scrollTo(0,0);
						})
					}
					
          this.showHeader = !this.showHeader
					this.txtflag = this.showHeader
				
        
			},

			// 跳转错题反馈
			jumpReaction(){
        this.$router.push({ path: '/reaction', query: { question_id: this.list[this.qusetNum - 1].id, qusetNum: this.qusetNum, examination_id: this.$route.query.examination_id,type: 'text' } })
			}

		}
	};
</script>
<style lang="less" scoped>
ul li:last-child {
	margin-bottom: 0;
}

.animal {
	animation: show 1s;
	animation-fill-mode:forwards;
}

@keyframes show {
	0% {
		display: none;
	}
	100% {
		display: block;
	}
}

</style>
<style>
#contain img{
max-width: 100%;
width: auto!important;
display: inline-block;
}
</style>